var hasSubMenu = document.querySelectorAll(".navigation__item--has-children");
var menuToggle = document.querySelector(".navbar__menu-button ");
var menuWrapper = document.querySelector(".navbar__navigation");
var menuText = document.querySelector(".hamburger__text");

Array.prototype.forEach.call(hasSubMenu, function(el, i) {
  var activatingA = el.querySelector(".navigation__link");
  var btn =
    "<button class=\"submenu__toggle sr-only\"><span><span class=\"sr-only\">show submenu for “" +
    activatingA.text +
    "”</span></span></button>";
  activatingA.setAttribute("aria-haspopup", true);
  activatingA.setAttribute("aria-expanded", false);
  activatingA.setAttribute("aria-label", "Open Submenu");
  activatingA.insertAdjacentHTML("afterend", btn);
  activatingA.addEventListener("click", function(event) {
    event.preventDefault();
    let submenu = el.querySelector(".navbar__navigation--sub-menu");
    submenu.classList.toggle("open");
    if (submenu.classList.contains("open")) {
      activatingA.setAttribute("aria-expanded", true);
      activatingA.setAttribute("aria-label", "Close Submenu");
    } else {
      activatingA.setAttribute("aria-expanded", false);
      activatingA.setAttribute("aria-label", "Open Submenu");
    }
  });
});

document.addEventListener("click", function(event) {
  try {

    if ((menuWrapper.classList.contains("open") && !menuWrapper.contains(event.target)) || menuToggle.contains(event.target)) {
      menuWrapper.classList.toggle("open");
      menuToggle.classList.toggle("is-active");
      menuText.innerText === "MENU" ? (menuText.innerText = "CLOSE") : (menuText.innerText = "MENU");
    }
  } catch (e) {

  }
});





const topbarLoginButtons = document.querySelectorAll("[data-login]");
const loginScreen = document.querySelector("#top-bar__log-in-screen");

topbarLoginButtons.forEach((loginButton, idx) => {

  loginButton.addEventListener("click", function (event) {
    const settings = drupalSettings?.nada_okta?.loginRedirect || {};
    if (settings.enabled) {
      event.preventDefault();
      window.location.href = settings.url;
    } else {
      loginButton.classList.toggle("is-active");
      if (loginScreen) {
        loginScreen.classList.toggle("open");
      }
      window.scrollTo(0, 0);
    }
  });
});

// [nada_okta][logout] robust handler (theme-level, no wrappers)
// Comments in English per project guideline

// Safe access to drupalSettings
const _ds = (typeof drupalSettings === "object" && drupalSettings) ? drupalSettings : {};
const logoutSettings = (_ds.nada_okta && _ds.nada_okta.logoutRedirect) || {};
const logoutTriggers = document.querySelectorAll("[data-logout]");

// Prevent duplicate navigations across all triggers
let __logoutNavigating = false;

// Resolve target URL from settings or element attributes
function __resolveLogoutTarget(el) {
  const configured = (typeof logoutSettings.url === "string" && logoutSettings.url.trim()) || "";
  const attrHref = el.getAttribute("href") || el.getAttribute("data-href") || "";
  return configured || attrHref;
}

// Validate URL: http/https only; same-origin unless allowExternal === true
function __isAllowedUrl(url) {
  try {
    const u = new URL(url, window.location.origin); // support relative hrefs
    if (!/^https?:$/.test(u.protocol)) return false; // http/https only
    if (u.origin === window.location.origin) return true; // same-origin ok
    return !!logoutSettings.allowExternal; // external only if explicitly allowed
  } catch (e) {
    return false; // malformed URL
  }
}

logoutTriggers.forEach((logoutTrigger, idx) => {
  // Avoid binding the same element multiple times
  if (logoutTrigger.dataset.logoutBound === "1") return;
  logoutTrigger.dataset.logoutBound = "1";

  logoutTrigger.addEventListener("click", function (event) {
    // If redirect is disabled, allow default behavior
    if (!logoutSettings.enabled) {
      return;
    }

    // Respect user intent for new tab/window (Ctrl/Meta/Shift or middle click)
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1) {
      return;
    }

    const targetUrl = __resolveLogoutTarget(logoutTrigger);
    if (!targetUrl) {
      return;
    }

    if (!__isAllowedUrl(targetUrl)) {
      return;
    }

    if (__logoutNavigating) {
      // Already navigating: block subsequent clicks
      event.preventDefault();
      return;
    }

    event.preventDefault();
    __logoutNavigating = true;

    // Use replace to reduce the chance of landing back on an authenticated page via Back
    try {
      const u = new URL(targetUrl, window.location.origin);
      window.location.replace(u.href);
    } catch (e) {
      // As a last resort, if URL constructor fails, fall back to href
      window.location.replace(targetUrl);
    }
  }, { passive: false }); // we call preventDefault(), so passive must be false
});


const topbarSearchButton = document.querySelector("#top-bar__search");
const searchScreen = document.querySelector("#top-bar__search-screen");
if (topbarSearchButton && searchScreen) {
  topbarSearchButton.addEventListener("click", function() {
    topbarSearchButton.classList.toggle("is-active");
    searchScreen.classList.toggle("open");
    var buttonText = topbarSearchButton.querySelector(".text");
    var icon = topbarSearchButton.querySelector("img");
    buttonText.innerHTML == "Search" ?
      (buttonText.innerHTML = "Close") :
      (buttonText.innerHTML = "Search");
    icon.getAttribute("src") == "/themes/custom/nada/images/icons/search.svg" ?
      icon.setAttribute("src", "/themes/custom/nada/images/icons/close.svg") :
      icon.setAttribute("src", "/themes/custom/nada/images/icons/search.svg");
  });
}
